import { plainToInstance } from 'class-transformer'
import Vue from "vue";
import i18n from 'vue-i18n'

import { MenuSectionNames, SocketNames } from '../../../../../components'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import IntegrationSampleNode from '../ui/SampleNode/IntegrationSampleNode.vue'
import IntegrationSidebar from '../ui/Sidebar/IntegrationSidebar.vue'

export default class IntegrationNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Additionally
  sidebarComponent = IntegrationSidebar

  constructor(i18n: i18n, sampleNode?: typeof Vue, builder?: typeof CustomNode,) {
    super(sampleNode ?? IntegrationSampleNode, builder ?? IntegrationNode, NodeTypes.Integration, i18n)
  }

  getNodeData() {
    return plainToInstance(IntegrationNodeData, {
      type: NodeTypes.Integration,
      data: {},
      fail_output: CustomNode.LastSocketId += 1
    })
  }

  getBaseNodeModel = ([ x, y ]: [ number, number ]) => {
    return {
      data: this.getNodeData(),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class IntegrationNode extends CustomNode {
  data: IntegrationNodeData

  constructor(name: NodeTypes.Integration, model: BaseNodeModel) {
    super(name, model)

    if (model.data instanceof IntegrationNodeData) {
      this.data = model.data

      this.socketActions.createOutput(model.data.fail_output, SocketNames.Fail)
    } else {
      throw new Error('To node come unknown data')
    }
  }
}

export class IntegrationNodeData extends BaseNodeModelData {
  declare type: NodeTypes.Integration

  source!: number
  data!: unknown
  fail_output!: number
}
